import React from "react";
import { Select, Form, Row, Col, Modal, notification } from "antd";
import ControlledSelect from "../../components/Backoffice/ControlledSelect";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const { Option } = Select;

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for name")
    .label("Name of Commodity"),
  category: yup.string().required().label("Commodity Category"),
});

const openNotification = () => {
  notification.success({
    message: "Success!",
    description: "Added new commodity",
    onClick: () => {
      console.log("Notification Clicked!");
    },
  });
};

const CommodityForm = ({ visible, setVisible, onSave, categories = [] }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      category: "",
    },
    resolver: yupResolver(schema),
  });

  const getOptions = (entries) => {
    const opts = [];
    entries.forEach((entry) => {
      opts.push(
        <Option key={entry._id} value={entry._id}>
          {entry.name}
        </Option>
      );
    });
    return opts;
  };

  const handleSuccess = () => {
    reset();
    setVisible(false);
    openNotification();
  };

  const handleFailure = () => {
    console.log("An error occured");
  };

  const onSubmit = (data) => {
    const payloadData = {
      name: data.name.trim().split(/ +/).join(" "),
      category: data.category,
    };
    const payload = {
      onSuccess: handleSuccess,
      data: payloadData,
      onFailure: handleFailure,
    };

    onSave(payload);
  };

  const handleCancel = () => {
    reset();
    setVisible(false);
  };

  return (
    <Modal
      title="Add Commodity"
      visible={visible}
      okText="Save"
      onOk={handleSubmit(onSubmit)}
      onCancel={handleCancel}
    >
      <Form colon={false}>
        <Row gutter={24}>
          <Col span={24}>
            <ControlledSelect
              required
              control={control}
              name="category"
              label="Commodity Category"
              options={getOptions(categories)}
              errors={errors}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={24}>
            <ControlledInput
              required
              control={control}
              name="name"
              label="Commodity Name"
              errors={errors}
            />
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default CommodityForm;
